import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M8.5 0h-7A1.5 1.5 0 0 0 0 1.5v5A1.5 1.5 0 0 0 1.5 8H2v1.5a.5.5 0 0 0 .283.451A.5.5 0 0 0 2.5 10a.5.5 0 0 0 .312-.109L5.176 8H8.5A1.5 1.5 0 0 0 10 6.5v-5A1.5 1.5 0 0 0 8.5 0"
    }, null, -1)
  ]));
}
const mailChatBubbleSquare = { render };
export {
  mailChatBubbleSquare as default,
  render
};
//# sourceMappingURL=mail-chat-bubble-square.svg.js.map
